import React, {Component} from 'react';
import $jq from "jquery";
import "./preview.css";

/**
 * creat by xcc
 * @description 网站，微信，微博，快手预览
 * @class Preview
 * @extends {BaseComponent}
 */
export default class Preview extends Component {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    mediaConfig = [
        {
            key: "gzh",
            name: "微信",
            component: "wechatView",
            onClick: (record, clickItem) => {
                clickItem.component && this[clickItem.component + '_' + clickItem.key].show(record, clickItem);
                this.setState({})
            }
        },
        {
            key: "wz",
            name: "网站",
            onClick: (record, clickItem) => {
                window.open(record.url)
            }
        },
        {
            key: "wb",
            type: 3,
            name: "微博",
            component: "weiBoView",
            onClick: (record, clickItem) => {
                clickItem.component && this[clickItem.component + '_' + clickItem.key].show(record, clickItem);
            }
        },
        {
            key: "dy",
            type: 5,
            name: "抖音",
            component: "weiBoView",
            onClick: (record, clickItem) => {
                clickItem.component && this[clickItem.component + '_' + clickItem.key].show(record, clickItem);
            }
        },
    ]

    openModal(record) {
        const {typeData = []} = this.props;
        let clickTypeObj = typeData.find(item => item.id === record.positionTypeId) || {};
        let clickItem = this.mediaConfig.find(item => item.key === clickTypeObj.code) || {};
        clickItem.onClick(record, clickItem)
    }

    /**
     * 添加敏感词鼠标悬浮效果
     */
    time = 0;
    throttle = (call) => {
        setTimeout(() => {
            call && call()
        }, 100)
    };
    hoverText = () => {
        let preview_content = $jq(".preview_content");
        preview_content.on('mouseover', ".currentWord_newMedia", (e) => {
            console.log("'mouseenter'");
            this.throttle(() => {
                this.enter(e)
            });
        });
        preview_content.on('mousemove', ".currentWord_newMedia", (e) => {
            console.log("mousemove");
            this.throttle(() => {
                this.move(e)
            });
        });
        preview_content.on('mouseout', ".currentWord_newMedia,.correctWord", (e) => {
            console.log("mouseout");
            this.throttle(() => {
                this.out(e)
            });
        });
        preview_content.on('mouseleave ', ".currentWord_newMedia,.correctWord", (e) => {
            console.log("mouseleave");
            this.throttle(() => {
                this.out(e)
            });
        });
    };

    move = (e) => {
        e.preventDefault();
        let dom = $jq(".correctWord");
        if (dom?.length) {
            let clientX = e.clientX;
            let clientY = e.clientY;
            dom.css("left", clientX);
            dom.css("top", clientY)
        } else {
            this.enter(e)
        }
    };

    enter = (e) => {
        e.preventDefault();
        let clientX = e.clientX - 2;
        let clientY = e.clientY + 2;
        var currWord = e.target.attributes.check.value;
        $jq('.correctWord').remove();
        let dome = '<span style="left:' + clientX + 'px;top:' + clientY + 'px  " class="correctWord">' +
            '<span></span>' +
            '<span>' + currWord + '</span>' +
            '</span>';
        $jq(".preview_content").append(dome);
    };

    out = (e) => {
        e.preventDefault();
        $jq('.correctWord').remove()
    };

    render() {
        let Component = null;
        return this.mediaConfig.map((item, index) => {
            let component = item.component;
            if (component && typeof component === "string") {
                try {
                    Component = require(`./component/${component}`).default
                } catch (e) {
                    console.log(e.toString())
                }
            }
            let dom = <div>数据加载错误</div>;
            if (Component) {
                dom = <Component
                    hoverText={this.hoverText}
                    ref={ref => {
                        this[item.component + '_' + item.key] = ref
                    }}
                    {...item}
                    {...this.state}
                />;
            }
            return dom
        })
    }

}